import { stringifyDocument } from './parser';

function textToBase(input) {
    // Примусове перетворення в строку
    const str = String(input);

    // Кодування в UTF-8, потім в Base64
    const utf8Encoded = new TextEncoder().encode(str);
    const base64String = btoa(String.fromCharCode(...utf8Encoded));

    return base64String;
}

function getPreParsedData(diagramDetails, scale, originXY, elements, lines, areas) {
    let data = {
        tables: [],
        lines: [],
        areas: [],
        globals: [],
        globalsMap: {},

        notes: [],
        pens: [],
    }

    data.globals = [
        { key: "title", value: diagramDetails?.title },
        { key: "description", value: diagramDetails?.description },
        { key: "db_engine", value: diagramDetails?.db_engine },
        { key: "scale", value: `${scale}` },
        { key: "origin", value: `${originXY.x} ${originXY.y}` },
    ];

    data.globalsMap = {
        title: diagramDetails?.title,
        description: diagramDetails?.description,
        db_engine: diagramDetails?.db_engine,
        scale: `${scale}`,
        origin: `${originXY.x} ${originXY.y}`,
    }

    for (const key in elements) {
        const element = elements[key];

        switch (element.type) {
            case 'table': {
                let elementData = {
                    name: element?.value?.header?.name || "",
                    columns: [],
                    attributes: {
                        xy: `${element.x} ${element.y}`,
                        txy: `0 0`,
                        wh: `${element.width} ${element.height}`,

                        ...(element.value.border && { border: element.value.border }),
                        ...(element.value.color && { color: element.value.color }),
                        ...(element.value.description && { note: element.value.description }),
                    },
                };

                for (const columnKey in element.value.columns) {
                    const column = element.value.columns[columnKey];

                    elementData.columns.push({
                        name: column.name,
                        type: column.type,
                        flags: {
                            ...(column.isPK && { pk: true }),
                            ...(column.isFK && { fk: true }),
                            ...(column.isNN && { not_null: true }),
                            ...(column.isAutoIncrement && { increment: true }),
                        },
                        attributes: {
                            ...(column.defaultValue && { default: column.defaultValue }),
                            ...(column.checkValue && { check: column.checkValue }),
                            ...(column.generatedValue && { generated_value: column.generatedValue }),
                            ...(column.isEnum && column.enumValues?.length && { enum: column.enumValues.join(',') }),
                            ...(column.index && { index: column.index.type }),
                            ...(column.description && { note: column.description }),
                        }
                    });
                }
                data.tables.push(elementData);
                break;
            }
            // case 'pen-segment': {
            //     let elementData = {
            //         type: 'pen',
            //         attributes: {
            //             xy: `${element.x} ${element.y}`,
            //             txy: `${element.translateX} ${element.translateY}`,
            //             wh: `${element.width} ${element.height}`,

            //             oxy: `${element.value.origin.x} ${element.value.origin.y}`,
            //             scale: `${element.value.scale}`,
            //             path: `${element.value.path}`,

            //             ...(element.color && { color: element.value.color }),
            //             ...(element.note && { note: element.value.note }),
            //         },
            //     };
            //     data.pens.push(elementData);
            //     break;
            // }
            default:
                break;
        }
    }

    for (const key in lines) {
        const line = lines[key];

        const fromElement = elements[line.value.fromElementId];
        const toElement = elements[line.value.toElementId];

        if (!fromElement || !toElement) {
            continue;
        }

        const fromInsideElement = fromElement.value.columns[line.value.fromInsideElementId];
        const toInsideElement = toElement.value.columns[line.value.toInsideElementId];

        if (!fromInsideElement || !toInsideElement) {
            continue;
        }

        const isMore = ['many', 'many-null'].includes(line.value.fromRelationType) && ['empty', 'one', 'one-null'].includes(line.value.toRelationType);
        const isLess = ['empty', 'one', 'one-null'].includes(line.value.fromRelationType) && ['many', 'many-null'].includes(line.value.toRelationType);

        let lineData = {
            arrow: isMore ? '>' : isLess ? '<' : '-',
            from: {
                table: fromElement?.value?.header?.name || "",
                columns: [fromInsideElement.name],
            },
            to: {
                table: toElement?.value?.header?.name || "",
                columns: [toInsideElement.name],
            },
            attributes: {
                from_type: line.value.fromRelationType,
                to_type: line.value.toRelationType,

                ...(line.value.onDeleteTrigger && { on_delete: line.value.onDeleteTrigger }),
                ...(line.value.onUpdateTrigger && { on_update: line.value.onUpdateTrigger }),

                ...(line.value.solidType && { solid_type: line.value.solidType }),
                ...(line.value.color && { color: line.value.color }),
                ...(line.value.description && { note: line.value.description }),
            },
        };

        data.lines.push(lineData);
    }

    for (const key in areas) {
        const area = areas[key];

        let areaData = {
            attributes: {
                xy: `${area.x} ${area.y}`,
                wh: `${area.width} ${area.height}`,

                ...(area.value.border && { border: area.value.border }),
                ...(area.value.color && { color: area.value.color }),
                ...(area.value.description && { note: area.value.description }),
            },
            elements: []
        };

        area.value.nestedElementsIds.forEach(elementId => {
            const element = elements[elementId];

            switch (element.type) {
                case 'table': {
                    let tableName = element?.value?.header?.name || "";
                    if (tableName) {
                        areaData.elements.push(tableName);
                    }
                    break;
                }
                default:
                    break;
            }
        });

        data.areas.push(areaData);
    }

    // console.log("DATA\n", data);
    return data;
}

function encode(diagramDetails, scale, originXY, elements, lines, areas) {
    let result = null;
    let isError = false;

    try {
        let preParsedData = getPreParsedData(diagramDetails, scale, originXY, elements, lines, areas);
        const code = stringifyDocument(preParsedData);
        result = textToBase(code);
    } catch (err) {
        isError = true;
    }
    return [result, isError];
}

export { encode };







// let updCode = `
//             -- title="Role & Permission Management"
//     -- description="This sample is a lightweight system for managing users, roles, and permissions in modern web apps. It uses role-based access control (RBAC) to clearly define what each user is allowed to do."
//     -- db_engine="postgresql"
//     -- scale="1.2"
//     -- origin=123123.3 23423.2

//                  users xy="12312.2 12312.2" txy="0 0" border="solid" color="blue" note="some comment"
//         id int pk fk not_null increment index="unique" enum="" default_value="" generated_value="" check="" note="some comment"
//         name varchar(50) not_null index="unique" enum="" default_value="" generated_value="" check="" note="some comment"

//       l: users.id > roles.id on_delete="cascade" on_update="cascade" note="user has a role"

//       a: "xy=12312.2 12312.2" "wh=12312.2 12312.2" border="solid" color="blue" note="some comment"
//     users
//     roles

//       roles xy="12312.2 12312.2" txy="0 0" border="solid" color="blue" note="some comment"
//         id int pk fk not_null increment index="unique" enum="" default_value="" generated_value="" check="" note="some comment"
//         name varchar(50) not_null index="unique" enum="" default_value="" generated_value="" check="" note="some comment"

//         p: xy="12312.2 12312.2" txy="12312.2 12312.2" oxy="12312.2 12312.2" color="yellow" path="M-1525.68, -1517.04 Q-1499.20, -1462.49 ..."
//     p: xy=100 200 color="red" path="M0,0 L10,10"

//         n: "Title with spaces" xy="123 456" wh="320 200" color="blue"
//     n: "some note" "xy=10 20" wh="300 100"

//     a: "xy=12312.2 12312.2" "wh=12312.2 12312.2" border="solid" color="blue" note="some comment"
//     users
//     roles

//     n: "top-left sticker" id="n1" xy="100 200" wh="120 80"
//     n: "another" xy="300 200" wh=160 60
//     `;













// let updatedScale = Number(scale.toFixed(1));
// let updatedOriginXY = { x: Number(originXY.x.toFixed(1)), y: Number(originXY.y.toFixed(1)) };
